import { Component, ContentChild, ElementRef, Input, OnInit, TemplateRef, ViewChild, AfterContentInit } from '@angular/core';
import { PageHeaderContent } from './page-header.model';
import { PageHeaderHeadlineDirective, PageHeaderButtonsDirective, PageHeaderStickyDirective } from './page-header-templates';
import * as _ from 'lodash';

@Component({
    selector: 'ig-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    standalone: false
})
export class PageHeaderComponent implements OnInit, AfterContentInit {

  @Input() content?: PageHeaderContent;
/*
  @ContentChild('templateHeadline') headlineContent: TemplateRef<any>;
  @ContentChild('templateButtons') buttonsContent: TemplateRef<any>;
  @ContentChild('templateStickyButtons') stickyContent: TemplateRef<any>;
*/
  @ContentChild(PageHeaderHeadlineDirective) headlineChild?: PageHeaderHeadlineDirective;
  @ContentChild(PageHeaderButtonsDirective) buttonsChild?: PageHeaderButtonsDirective;
  @ContentChild(PageHeaderStickyDirective) stickyChild?: PageHeaderStickyDirective;

  @ViewChild('igPageHeaderActions', { static: true }) headerActions?: ElementRef;
  @ViewChild('igPageHeaderStickyActions', { static: true }) stickyActions?: ElementRef;

  /**
   * @ignore
   */
  showStickyActions: boolean = false;

  headlineTemplate?: TemplateRef<unknown>;
  buttonsTemplate?: TemplateRef<unknown>;
  stickyTemplate?: TemplateRef<unknown>;



  ngOnInit(): void {
    if (
      this.content &&
      this.content.stickyButtons &&
      this.content.stickyButtons.enabled &&
      this.content.stickyButtons.offsetContainer
      ) {
      this.handleStickyActions(this.content.stickyButtons.offsetContainer);
    }
  }

  ngAfterContentInit() {
    if (this.headlineChild) {
      this.headlineTemplate = this.headlineChild.templateRef;
    }
    if (this.buttonsChild) {
      this.buttonsTemplate = this.buttonsChild.templateRef;
    }
    if (this.stickyChild) {
      this.stickyTemplate = this.stickyChild.templateRef;
    }
  }


  handleStickyActions(offsetContainerSelector: string) {
    let offsetTop = 0;
    const offsetElement = document.querySelector(offsetContainerSelector);
    if (offsetElement) {
      offsetTop = offsetElement.getBoundingClientRect().top;
    }
    this.stickyActions?.nativeElement.style.setProperty("--ig-page-header-buttons-offset-top", offsetTop + 'px');

    window.addEventListener("scroll", ()=>{
      this.stickyActions?.nativeElement.style.setProperty("--ig-page-header-buttons-offset-right", (document.body.clientWidth - _.toInteger(this.headerActions?.nativeElement.getBoundingClientRect().right)) + 'px');

      const headerActionsTop = _.toInteger(this.headerActions?.nativeElement.getBoundingClientRect().top);
      if (headerActionsTop <= offsetTop) {
        this.showStickyActions = true;
      } else {
        this.showStickyActions = false;
      }
    });
  }

}

